import { render, staticRenderFns } from "./MandatoryExtraOnOrder.vue?vue&type=template&id=310c1ccf&scoped=true&"
import script from "./MandatoryExtraOnOrder.vue?vue&type=script&lang=js&"
export * from "./MandatoryExtraOnOrder.vue?vue&type=script&lang=js&"
import style0 from "./MandatoryExtraOnOrder.vue?vue&type=style&index=0&id=310c1ccf&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "310c1ccf",
  null
  
)

export default component.exports